import { useState } from "react";
import { useEffect } from "react";


/**
 * Renders the provided HTML element as props.
 * Sets the width and height of the rendered element.
 * ⚠ Warning: Utilizes `dangerouslySetInnerHTML` to add the element.
 * 
**/
const ServerElement = ({htmlElement}) => {
  let { blockHeight, blockWidth, htmlBlock } = htmlElement;
  const [ innerHTML, setInnerHTML ] = useState();

  
  if (!blockWidth)
    blockWidth = "100%";
  if (!blockHeight)
    blockHeight = "100%";

  useEffect(() => {
    setInnerHTML(htmlBlock);
  }, [htmlBlock])


  return (
    <div 
      style={{width: blockWidth, height: blockHeight, overflow: "auto"}}
    >
      <div dangerouslySetInnerHTML={{ __html: innerHTML }}></div>
    </div>
  )
}

export default ServerElement;
